export default "https://c.travel-assets.com/partner-portal/phone.7d21001dad8d.svg";